import React, { useState, useEffect, useRef } from "react";
import { View, Text, Animated, StyleSheet } from "react-native";
import { SHADOW_COLORS } from "../../style/colors.js";

const CustomPopup = ({ message, tiempo, isVisible, onHide }) => {
  const fadeAnim = useRef(new Animated.Value(0)).current; // Usar useRef para persistir el valor
  const timerRef = useRef(); // Referencia para manejar el temporizador

  const backgroundColors = {
    A: "rgba(0, 128, 0, 9)", // Verde
    B: "rgba(255, 166, 0, 9)", // Naranja suave
    C: "rgba(255, 97, 0, 9)", // Naranja
  };

  useEffect(() => {
    if (isVisible) {
      // Fade in
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 500,
        useNativeDriver: true,
      }).start();

      // Después de 3.5 segundos, fade out
      timerRef.current = setTimeout(() => {
        Animated.timing(fadeAnim, {
          toValue: 0,
          duration: 500,
          useNativeDriver: true,
        }).start(() => onHide()); // Llama a onHide después de la animación
      }, 3000);
    }

    return () => {
      // Limpia el temporizador si el componente se desmonta
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isVisible, fadeAnim, onHide]);

  if (!isVisible) return null;

  return (
    <Animated.View
      style={[
        styles.popupContainer,
        { backgroundColor: backgroundColors[tiempo] || "grey" }, // Selecciona el color basado en tiempo
        { opacity: fadeAnim }, // Aplica animación
      ]}>
      <Text style={styles.popupText}>{message}</Text>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  popupContainer: {
    position: "absolute",
    height: "80%",
    width: "100%",
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    borderRadius: 20, // Bordes redondeados
    shadowColor: SHADOW_COLORS.PRIMARY, // Color de la sombra
    shadowOffset: { width: 0, height: 2 }, // Desplazamiento de la sombra
    shadowOpacity: 0.25, // Opacidad de la sombra
    shadowRadius: 3.84, // Radio de la sombra
    elevation: 5, // Elevación para Android
  },
  popupText: {
    color: "white",
    fontSize: 16, // Tamaño de letra más grande
    fontWeight: "bold", // Letra en negrita
  },
});

export default CustomPopup;
